import { KPIPill } from "PFApp/components/kpi_pill";
import { ProfileItem } from "PFApp/components/profile_item";
import { Typography } from "PFComponents/typography";
import { useDateFormatter } from "PFCore/hooks";
import { KPIEvent, KPIStatus, KPIUnit as KPIUnitEnum } from "PFCore/types/kpi";
import { useTranslation } from "react-i18next";

import css from "../kpi_events_list.module.scss";
import { useEventText } from "./hooks/use_event_text";
import { isEvaluationErrorEvent, isSystemEvent } from "./kpi_event_tile.utils";
import { KPIEventTileBase } from "./kpi_event_tile_base";

type KPIEventTileProps = {
  event: KPIEvent;
  KPIUnit: KPIUnitEnum;
};

export const KPIEventTile = ({ event, KPIUnit }: KPIEventTileProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "KPIsReviewSidepanel" });
  const { formatDateTime } = useDateFormatter();
  const text = useEventText(event, KPIUnit);

  return (
    <KPIEventTileBase>
      <div className={css.headline}>
        {isSystemEvent(event) ? (
          <Typography variant="bodyBold">
            {isEvaluationErrorEvent(event) && t("evaluationError")}
            {event.status === KPIStatus.OnTarget && t("KPICompliant")}
            {event.status === KPIStatus.ApprovalRequired && t("KPIException")}
          </Typography>
        ) : (
          <ProfileItem profile={event.profile!} />
        )}
      </div>
      {text && <Typography variant="bodyRegular">{text}</Typography>}
      <Typography variant="labelRegular" className={css.date}>
        {formatDateTime(event.createdAt)}
      </Typography>
      {!!event.status && <KPIPill kpiStatus={event.status} />}
    </KPIEventTileBase>
  );
};
